import React, { useEffect, useState } from "react";
import BaseLayout from "../../../components/Layout";
import {
  RefreshCw,
  Wifi,
  Settings,
  Download,
  Lock,
  Unlock,
  Cpu,
  Globe,
  Search,
  AlertTriangle,
  Radio,
  Database,
  Calendar,
  X,
  Check,
  Activity,
} from "lucide-react";
import "./styles.scss";
import {
  cancelarComandos,
  enviarComandoRemoto,
  fetchCentralParams,
} from "../../../features/tecnico/comandos/slices";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

const TecnicoComandosPage = () => {
  const [idCentral, setIdCentral] = useState<string>("");
  const [firmwareFile, setFirmwareFile] = useState<string>("");
  const [dataAgendamento, setDataAgendamento] = useState<string>("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingCmd, setEditingCmd] = useState<number | null>(null);
  const [tempParams, setTempParams] = useState<any>(null);

  const dispatch = useDispatch<AppDispatch>();
  const {
    centralParams,
    loading: loadingRedux,
    success,
    error,
  } = useSelector((state: RootState) => state.tecnicoCmd);

  const comandos = [
    { id: 1, label: "Reset Placa", icon: <RefreshCw />, color: "danger" },
    { id: 10, label: "Reset WiFi", icon: <Wifi />, color: "warning" },
    { id: 2, label: "Reset GPRS", icon: <Globe />, color: "warning" },
    { id: 3, label: "Ativar AP", icon: <Cpu />, color: "info" },
    { id: 6, label: "Pedir Parâmetros", icon: <Search />, color: "primary" },
    {
      id: 4,
      label: "Alterar Dispositivo",
      icon: <Settings />,
      color: "secondary",
    },
    { id: 5, label: "Alterar Conexão", icon: <Wifi />, color: "secondary" },
    {
      id: 7,
      label: "Atualizar Firmware",
      icon: <Download />,
      color: "success",
    },
    { id: 8, label: "Bloquear", icon: <Lock />, color: "danger" },
    { id: 9, label: "Desbloquear", icon: <Unlock />, color: "success" },
  ];

  const handleBuscar = () => {
    if (!idCentral) return alert("Digite o ID da Central");
    dispatch(fetchCentralParams(Number(idCentral)));
  };

  const abrirModalEdicao = (cmdId: number) => {
    if (!centralParams)
      return alert("Carregue os parâmetros da central primeiro!");
    setEditingCmd(cmdId);
    setTempParams(JSON.parse(JSON.stringify(centralParams)));
    setIsModalOpen(true);
  };

  const handleEnviarComando = (cmdNumber: number, paramObj: any = null) => {
    if (!idCentral) return alert("Selecione uma central primeiro.");

    const dataParaEnvio = dataAgendamento
      ? new Date(dataAgendamento).toISOString()
      : new Date().toISOString();

    const payload: any = {
      idCentral: Number(idCentral),
      cmdNumber: cmdNumber,
      programacao: dataParaEnvio,
      param: paramObj,
    };

    if (cmdNumber === 7) {
      if (!firmwareFile) return alert("Digite o nome do arquivo de firmware.");
      payload.firmwareFileName = firmwareFile;
    }

    dispatch(enviarComandoRemoto(payload));
    setIsModalOpen(false);
  };

  const handleCancelar = () => {
    if (window.confirm("Deseja cancelar todos os comandos pendentes?")) {
      dispatch(cancelarComandos(Number(idCentral)));
    }
  };

  useEffect(() => {
    if (success) alert("Comando enviado/agendado com sucesso!");
    if (error) alert("Erro: " + error);
  }, [success, error]);

  return (
    <BaseLayout>
      <div className="comandos-tecnicos-container">
        <header className="page-header">
          <div className="title-box">
            <Cpu size={32} />
            <div>
              <h1>Console de Comando Remoto</h1>
              <p>Gerenciamento direto de hardware e firmware</p>
            </div>
          </div>

          <div className="search-bar">
            <input
              type="number"
              placeholder="ID Central"
              value={idCentral}
              onChange={(e) => setIdCentral(e.target.value)}
            />
            <button
              className="btn-fetch"
              onClick={handleBuscar}
              disabled={loadingRedux}
            >
              <Search size={18} /> Carregar
            </button>
          </div>
        </header>

        <div className="main-grid">
          <section className="commands-section">
            <div className="section-header">
              <h2>Comandos de Execução</h2>
              <div className="scheduling-box">
                <label>
                  <Calendar size={14} /> Agendar para (Opcional):
                </label>
                <input
                  title={""}
                  type="datetime-local"
                  value={dataAgendamento}
                  onChange={(e) => setDataAgendamento(e.target.value)}
                />
              </div>
            </div>

            <div className="commands-grid">
              {comandos.map((cmd) => (
                <button
                  key={cmd.id}
                  className={`cmd-card ${cmd.color}`}
                  onClick={() => {
                    if (cmd.id === 4 || cmd.id === 5 || cmd.id === 6)
                      abrirModalEdicao(cmd.id);
                    else handleEnviarComando(cmd.id);
                  }}
                  disabled={loadingRedux}
                >
                  <div className="icon">{cmd.icon}</div>
                  <span>{cmd.label}</span>
                </button>
              ))}
            </div>
          </section>

          <aside className="params-aside">
            <div className="card-main">
              <div className="card-header-main">
                <div className="title-group">
                  <Activity size={20} className="icon-pulse" />
                  <h3>Monitoramento Atual</h3>
                </div>
                {centralParams && (
                  <div className="badge-id-pill">
                    <span className="label">ID CENTRAL</span>
                    <span className="value">{idCentral}</span>
                  </div>
                )}
              </div>

              {centralParams ? (
                <div className="params-content">
                  <div className="info-block">
                    <header>
                      <Database size={16} /> Parâmetros de Hardware
                    </header>
                    <div className="info-grid">
                      <div className="info-item full">
                        <label>Server Endpoint</label>
                        <span title={centralParams.paramMod?.server}>
                          {centralParams.paramMod?.server}
                        </span>
                      </div>
                      <div className="info-item">
                        <label>Taxa de Envio</label>
                        <p>
                          {centralParams.paramMod?.taxaEnvio}
                          <span>ms</span>
                        </p>
                      </div>
                      <div className="info-item">
                        <label>Limite Erro</label>
                        <p>{centralParams.paramMod?.apiErrorLimit}</p>
                      </div>
                      <div className="info-item">
                        <label>Resolução</label>
                        <p>
                          {centralParams.paramMod?.analogResolution}
                          <span>bits</span>
                        </p>
                      </div>
                      <div className="info-item">
                        <label>Versão</label>
                        <p>{centralParams.paramMod?.versao || "4.0"}</p>
                      </div>
                    </div>
                  </div>

                  <div className="info-block network">
                    <header>
                      <Radio size={16} /> Estado da Conexão
                    </header>
                    <div className="network-type">
                      <div
                        className={`type-indicator ${centralParams.paramCnn?.tipoCnn === 1 ? "wifi" : "gprs"}`}
                      >
                        {centralParams.paramCnn?.tipoCnn === 1 ? (
                          <Wifi size={14} />
                        ) : (
                          <Globe size={14} />
                        )}
                        {centralParams.paramCnn?.tipoCnn === 1
                          ? "WIFI"
                          : "GPRS"}
                      </div>
                    </div>
                    <div className="info-grid">
                      {centralParams.paramCnn?.tipoCnn === 1 ? (
                        <div className="info-item full">
                          <label>SSID da Rede</label>
                          <span>
                            {centralParams.paramCnn?.wifiSsid || "N/A"}
                          </span>
                        </div>
                      ) : (
                        <div className="info-item full">
                          <label>APN Operadora</label>
                          <span>
                            {centralParams.paramCnn?.gprsApn || "Padrão"}
                          </span>
                        </div>
                      )}
                      <div className="info-item full">
                        <label>Tentativas de Reconexão</label>
                        <p>
                          {centralParams.paramCnn?.wifiTryCount}{" "}
                          <span>vezes</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="params-empty">
                  <Search size={48} />
                  <p>Informe o ID para visualizar os parâmetros.</p>
                </div>
              )}

              <div className="firmware-box">
                <h4>Firmware (CMD 7)</h4>
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="arquivo.bin"
                    value={firmwareFile}
                    onChange={(e) => setFirmwareFile(e.target.value)}
                  />
                  <button
                    className="btn-action"
                    onClick={() => handleEnviarComando(7)}
                  >
                    Agendar
                  </button>
                </div>
              </div>

              <div className="danger-zone">
                <button className="btn-outline-danger" onClick={handleCancelar}>
                  <AlertTriangle size={16} /> Limpar Fila T20
                </button>
              </div>
            </div>
          </aside>
        </div>

        {isModalOpen && tempParams && (
          <div className="modal-overlay">
            <div className="modal-content">
              <div className="modal-header">
                <h3>
                  {editingCmd === 4 && "Configurar Hardware"}
                  {editingCmd === 5 && "Configurar Conexão"}
                  {editingCmd === 6 && "Atualizar Parâmetros Dispositivo"}
                </h3>
                <button title={""} onClick={() => setIsModalOpen(false)}>
                  <X />
                </button>
              </div>
              <div className="modal-body">
                {(editingCmd === 4 || editingCmd === 6) && (
                  <div className="form-grid-modal">
                    <div className="field-full-title">
                      <h4>Parâmetros do Dispositivo</h4>
                    </div>
                    <div className="field">
                      <label>Server (Endpoint)</label>
                      <input
                        title={""}
                        type="text"
                        value={tempParams.paramMod.server}
                        onChange={(e) =>
                          setTempParams({
                            ...tempParams,
                            paramMod: {
                              ...tempParams.paramMod,
                              server: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                    <div className="field">
                      <label>Porta</label>
                      <input
                        title={""}
                        type="number"
                        value={tempParams.paramMod.serverPort}
                        onChange={(e) =>
                          setTempParams({
                            ...tempParams,
                            paramMod: {
                              ...tempParams.paramMod,
                              serverPort: Number(e.target.value),
                            },
                          })
                        }
                      />
                    </div>
                    <div className="field">
                      <label>Taxa Envio (ms)</label>
                      <input
                        title={""}
                        type="number"
                        value={tempParams.paramMod.taxaEnvio}
                        onChange={(e) =>
                          setTempParams({
                            ...tempParams,
                            paramMod: {
                              ...tempParams.paramMod,
                              taxaEnvio: Number(e.target.value),
                            },
                          })
                        }
                      />
                    </div>
                    <div className="field">
                      <label>Erro Limit</label>
                      <input
                        title={""}
                        type="number"
                        value={tempParams.paramMod.apiErrorLimit}
                        onChange={(e) =>
                          setTempParams({
                            ...tempParams,
                            paramMod: {
                              ...tempParams.paramMod,
                              apiErrorLimit: Number(e.target.value),
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                )}

                {(editingCmd === 5 || editingCmd === 6) && (
                  <div
                    className={`form-grid-modal ${editingCmd === 6 ? "mt-20 border-top" : ""}`}
                  >
                    {editingCmd === 6 && (
                      <div className="field-full-title">
                        <h4>Parâmetros de Conectividade</h4>
                      </div>
                    )}
                    <div className="field">
                      <label>Tipo (1:WiFi, 0:GPRS)</label>
                      <input
                        title={""}
                        type="number"
                        value={tempParams.paramCnn.tipoCnn}
                        onChange={(e) =>
                          setTempParams({
                            ...tempParams,
                            paramCnn: {
                              ...tempParams.paramCnn,
                              tipoCnn: Number(e.target.value),
                            },
                          })
                        }
                      />
                    </div>
                    <div className="field">
                      <label>WiFi SSID</label>
                      <input
                        title={""}
                        type="text"
                        value={tempParams.paramCnn.wifiSsid}
                        onChange={(e) =>
                          setTempParams({
                            ...tempParams,
                            paramCnn: {
                              ...tempParams.paramCnn,
                              wifiSsid: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                    <div className="field">
                      <label>WiFi Pass</label>
                      <input
                        title={""}
                        type="password"
                        value={tempParams.paramCnn.wifiPass}
                        onChange={(e) =>
                          setTempParams({
                            ...tempParams,
                            paramCnn: {
                              ...tempParams.paramCnn,
                              wifiPass: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                    <div className="field">
                      <label>APN GPRS</label>
                      <input
                        title={""}
                        type="text"
                        value={tempParams.paramCnn.gprsApn}
                        onChange={(e) =>
                          setTempParams({
                            ...tempParams,
                            paramCnn: {
                              ...tempParams.paramCnn,
                              gprsApn: e.target.value,
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn-cancel"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancelar
                </button>
                <button
                  className="btn-confirm"
                  onClick={() => handleEnviarComando(editingCmd!, tempParams)}
                >
                  <Check size={16} /> Enviar Comando {editingCmd}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </BaseLayout>
  );
};

export default TecnicoComandosPage;
